// The study card's tag: the model writes <send_email_question to="..." ...>body</send_email_question>.

/** What the tag says about the patient, for the handoff to the study team (Rudi ADR 0144). */
export interface ReferralDetails {
  firstName?: string;
  lastName?: string;
  birthDate?: string;
  phone?: string;
  diagnosis?: string;
}

export interface SendEmailQuestionData {
  content: string;
  recipient: string;
  patientEmail: string;
  patientName: string;
  referral: ReferralDetails;
}

const TAG = /<send_email_question\b([^>]*)>([\s\S]*?)<\/send_email_question>/g;
const ATTRIBUTE = /([\w-]+)="([^"]*)"/g;

function attributes(text: string): Map<string, string> {
  return new Map(Array.from(text.matchAll(ATTRIBUTE), (match) => [match[1], match[2]]));
}

/** The cards in a message and the message without them. Stored messages carry fewer attributes. */
export function extractSendEmailQuestions(content: string): {
  sendEmailQuestions: SendEmailQuestionData[];
  cleanContent: string;
} {
  const sendEmailQuestions: SendEmailQuestionData[] = [];
  for (const match of content.matchAll(TAG)) {
    const tag = attributes(match[1]);
    const recipient = tag.get('to');
    const emailContent = match[2].trim();
    // Only add non-empty emails with a recipient.
    if (emailContent && recipient) {
      sendEmailQuestions.push({
        content: emailContent,
        recipient,
        patientEmail: tag.get('patient-email') ?? '',
        patientName: tag.get('patient-name') ?? '',
        referral: {
          firstName: tag.get('patient-first-name'),
          lastName: tag.get('patient-last-name'),
          birthDate: tag.get('patient-birth-date'),
          phone: tag.get('patient-phone'),
          diagnosis: tag.get('patient-diagnosis'),
        },
      });
    }
  }
  return { sendEmailQuestions, cleanContent: content.replace(TAG, '').trim() };
}
